export default "__VITE_ASSET__DBpH7g6O__"